<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <div class="tabs">
      <ul>
        <li>
          <router-link
            :to="{ name: 'reportDialy', params: { projectId: projectId } }"
          >
            Daily
          </router-link>
        </li>
        <li>
          <router-link
            :to="{ name: 'reportWeekly', params: { projectId: projectId } }"
          >
            Weekly
          </router-link>
        </li>
        <li class="is-active"><a>Monthly</a></li>
      </ul>
    </div>
    <h5 class="title is-5">{{ $t("reports.monthly") }}</h5>
    <MonthlyGraph :tenant-id="tenantId" :project-id="projectId"></MonthlyGraph>
    <hr />
    <MonthlyReports
      :tenant-id="tenantId"
      :project-id="projectId"
    ></MonthlyReports>
  </div>
</template>
<script>
import { ref, computed } from "@vue/reactivity";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import MonthlyGraph from "@/components/reports/monthlyGraph.vue";
import MonthlyReports from "@/components/reports/monthlyReports.vue";

export default {
  components: {
    Breadcrumb,
    MonthlyGraph,
    MonthlyReports,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const breadcrumb = ref([
      {
        title: "Home",
        path: {
          name: "dashboard",
          params: { projectId: route.params.projectId },
        },
      },
      { title: "Report", path: "#", isActive: true },
    ]);

    return {
      breadcrumb,
      tenantId: computed(() => store.getters.tenantId),
      projectId: computed(() => route.params.projectId),
    };
  },
};
</script>
